<mat-expansion-panel [togglePosition]="'before'">
    <mat-expansion-panel-header>
    <mat-panel-title>
        Employer Point of Contact Information
    </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="p-4">
    <!-- Employer Point of Contact Information -->
    <form [formGroup]="employerContactInfoForm">        
        <div class="row">
            <h5 class="col-md-8 labelText"> Employer Point of Contact Information </h5>      
            <div class="col-md-4 d-flex justify-content-end" *ngIf="isDuplicateLCA">
                <button class="clear-data-button" (click)="clearData()">
                    <i class="fa fa-repeat"></i> Clear Data
                 </button>
            </div>
        </div>
        <div class="row">
            <!-- Contact Person -->
            <div class="form-group col-md-4">
                <mat-form-field> 
                    <label class="label-cls required">Contact Person Name</label>
                    <mat-select name="contactPerson"
                                formControlName="contactPerson"
                                (selectionChange)="onChangeContactPerson($event.value)">
                      <mat-option *ngFor="let item of listContact" [value]="item?.id">
                        {{item?.empName}}
                      </mat-option> 
                    </mat-select>
                </mat-form-field>
                <span class="invalid-message"
                    *ngIf="(employerContactInfoForm.get('contactPerson').touched && employerContactInfoForm.get('contactPerson').errors?.required)">
                    {{ getGlobalErrorMessages("REQUIRED") }}
                </span>
            </div>
        </div>
        <div class="row mt-2">
            <!-- First Name -->
            <div class="form-group col-md-4"> 
                <label class="label-cls required">First Name (Given)</label>
                <input [ngClass]="isDisabledContact ? 'im-input disable' : 'im-input'"
                        name="firstName"
                        formControlName="firstName"
                        type="text"
                        placeholder="Enter"/>
                <span class="invalid-message"
                    *ngIf="(employerContactInfoForm.get('firstName').touched && employerContactInfoForm.get('firstName').invalid) || (employerContactInfoForm.get('firstName').touched && employerContactInfoForm.get('firstName').errors?.required)">
                    {{ getGlobalErrorMessages("INVALID_NAME") }}
                </span>
            </div>
            <!-- Middle Name -->
            <div class="form-group col-md-4"> 
                <label class="label-cls">Middle Name</label>
                <input [ngClass]="isDisabledContact ? 'im-input disable' : 'im-input'"
                        name="middleName"
                        formControlName="middleName"
                        type="text"
                        placeholder="Enter"/>
                <span class="invalid-message" 
                        *ngIf="(employerContactInfoForm.get('middleName').touched  && employerContactInfoForm.get('middleName').invalid)">
                {{ getGlobalErrorMessages("INVALID_NAME") }}
                </span>
            </div>
            <!-- Last Name (Family Name) -->
            <div class="form-group col-md-4"> 
                <label class="label-cls required">Last Name (Family Name)</label>
                <input [ngClass]="isDisabledContact ? 'im-input disable' : 'im-input'"
                        name="lastName"
                        formControlName="lastName"
                        type="text"
                        placeholder="Enter" />
                <span *ngIf="employerContactInfoForm.get('contactPerson').value === 'null'">
                    <span class="invalid-message"
                        *ngIf="(employerContactInfoForm.get('lastName').touched && employerContactInfoForm.get('lastName').invalid) || (employerContactInfoForm.get('lastName').touched && employerContactInfoForm.get('lastName').errors?.required) || (employerContactInfoForm.get('lastName').value && employerContactInfoForm.get('lastName').errors?.minlength)">
                        {{ getGlobalErrorMessages("INVALID_NAME_2") }}
                    </span>
                </span>
                <span *ngIf="employerContactInfoForm.get('contactPerson').value !== 'null'">
                    <span class="invalid-message"
                        *ngIf="(employerContactInfoForm.get('lastName').touched && employerContactInfoForm.get('lastName').invalid) || (employerContactInfoForm.get('lastName').touched && employerContactInfoForm.get('lastName').errors?.required) || (employerContactInfoForm.get('lastName').value && employerContactInfoForm.get('lastName').errors?.minlength)">
                        {{ getGlobalErrorMessages("INVALID_DBNAME_2") }}
                    </span> 
                </span>
                
            </div>
        </div> 
        <div class="row">
            <!-- Contact's Job Title -->
            <div class="form-group col-md-4"> 
                <label class="control-lbl mt-2 required label-cls">Contact's Job Title</label>
                <input [ngClass]="isDisabledContact ? 'im-input disable' : 'im-input'"
                        type="text" 
                        formControlName="jobTitle" 
                        placeholder="Enter" />
                <span *ngIf="employerContactInfoForm.get('contactPerson').value === 'null'">
                    <span class="invalid-message"
                        *ngIf="(employerContactInfoForm.get('jobTitle').touched && employerContactInfoForm.get('jobTitle').invalid) || (employerContactInfoForm.get('jobTitle').touched && employerContactInfoForm.get('jobTitle').errors?.required)">
                        {{ getGlobalErrorMessages("REQUIRED") }}
                    </span>
                </span>
                <span *ngIf="employerContactInfoForm.get('contactPerson').value !== 'null'">
                    <span class="invalid-message"
                        *ngIf="(employerContactInfoForm.get('jobTitle').touched && employerContactInfoForm.get('jobTitle').invalid) || (employerContactInfoForm.get('jobTitle').touched && employerContactInfoForm.get('jobTitle').errors?.required)">
                        {{ getGlobalErrorMessages("REQUIRED") }}
                    </span>
                </span>
            </div>
        </div>
        <div class="row">
            <!-- Address 1 -->
            <div class="form-group col-md-6">
                <label class="control-lbl mt-2 required label-cls">Address 1</label>
                <input [ngClass]="isDisabledContact ? 'im-input disable' : 'im-input'"
                        type="text" 
                        name="addressLine1"
                        formControlName="addressLine1"
                        placeholder="Enter" />
                <mat-hint>Ex. : Street Name & Number</mat-hint>
                <span class="invalid-message"
                    *ngIf="(employerContactInfoForm.get('addressLine1').touched && employerContactInfoForm.get('addressLine1').errors?.required)">
                    {{ getGlobalErrorMessages("REQUIRED") }}
                </span>
            </div>
        </div>
        <div class="row">
            <!-- Address 2 -->
            <div class="form-group col-md-6">
                <label class="control-lbl mt-2 label-cls">Address 2</label>
                <input [ngClass]="isDisabledContact ? 'im-input disable' : 'im-input'" 
                        type="text" 
                        name="addressLine2"
                        formControlName="addressLine2"
                        placeholder="Enter" />
                <mat-hint>Ex. : Apartment., Suite, Building</mat-hint>
            </div>
        </div>
        <div class="row  mt-2"> 
            <!-- Country -->
            <div class="form-group col-md-4">
                <mat-form-field> 
                    <label class="label-cls required">Country</label>
                    <mat-select [ngClass]="isDisabledContact ? 'disable' : ''" 
                                [disabled]="isDisabledContact"
                                name="country"
                                formControlName="country"
                                (selectionChange)="onChangeCountry($event.value)">
                      <mat-option *ngFor="let item of listCountry" [value]="item.countryCode">
                        {{item.countryName}}
                      </mat-option> 
                    </mat-select>
                </mat-form-field>

                <span class="invalid-message"
                    *ngIf="(employerContactInfoForm.get('country').touched && employerContactInfoForm.get('country').errors?.required)">
                    {{ getGlobalErrorMessages("REQUIRED") }}
                </span>
            </div>
            <!-- State -->
            <div class="form-group col-md-4">
                <mat-form-field> 
                    <label class="label-cls required">State</label>
                    <mat-select [ngClass]="isDisabledContact ? 'disable' : ''" 
                                [disabled]="isDisabledContact"
                                name="state"
                                formControlName="state">
                      <mat-option *ngFor="let item of listStates" [value]="item.state">
                        {{item.stateProvinceName}}
                      </mat-option> 
                    </mat-select>
                </mat-form-field>

                <span class="invalid-message"
                    *ngIf="(employerContactInfoForm.get('state').touched && employerContactInfoForm.get('state').errors?.required)">
                    {{ getGlobalErrorMessages("REQUIRED") }}
                </span>
            </div>
            <!-- City -->
            <div class="form-group col-md-4">
                <label class="col-md-12 required label-cls">City</label>
                <input [ngClass]="isDisabledContact ? 'im-input disable' : 'im-input'"
                        name="city"
                        formControlName="city"
                        type="text"
                        placeholder="Enter"/>
                <span class="invalid-message"
                    *ngIf="(employerContactInfoForm.get('city').touched && employerContactInfoForm.get('city').invalid) || (employerContactInfoForm.get('city').touched && employerContactInfoForm.get('city').errors?.required)">
                    {{ getGlobalErrorMessages("INVALID_CITY") }}
                </span>
            </div>
        </div>
        <div class="row  mt-2">
            <!-- ZIP / Postal Code -->
            <div class="form-group col-md-4"> 
                <label class="label-cls required">ZIP / Postal Code</label>
                <input [ngClass]="isDisabledContact ? 'im-input disable' : 'im-input'"
                        name="postalCode"
                        formControlName="postalCode"
                        type="text"
                        placeholder="Enter"/>
                <span class="invalid-message"
                    *ngIf="(employerContactInfoForm.get('postalCode').touched && employerContactInfoForm.get('postalCode').errors?.required)">
                    {{ getGlobalErrorMessages("REQUIRED") }}
                </span>
            </div>
            <!-- Province -->
            <div class="form-group col-md-4"> 
                <label class="label-cls">Province</label>
                <input [ngClass]="isDisabledContact ? 'im-input disable' : 'im-input'"
                        name="stateProvinceName"
                        formControlName="stateProvinceName"
                        type="text"
                        placeholder="Enter"/>
            </div>
            <!-- Extension -->
            <div class="form-group col-md-4"> 
                <label class="label-cls">Extension</label>
                <input [ngClass]="isDisabledContact ? 'im-input disable' : 'im-input'"
                        name="extension"
                        formControlName="extension"
                        type="text"
                        placeholder="Enter" />
                <span class="invalid-message" 
                        *ngIf="(employerContactInfoForm.get('extension').touched  && employerContactInfoForm.get('extension').invalid)">
                {{ getGlobalErrorMessages("INVALID_EXTENSION") }}
                </span>
            </div>
        </div> 
        <div class="row mt-2">
            <!-- Telephone Number -->
            <div class="form-group col-md-4"> 
                <label class="label-cls required">Telephone Number</label>
                <input [ngClass]="isDisabledContact ? 'im-input disable' : 'im-input'"
                        name="phoneNumber"
                        formControlName="phoneNumber"
                        type="text"
                        placeholder="Enter"/>
                <span class="invalid-message"
                    *ngIf="(employerContactInfoForm.get('phoneNumber').touched && employerContactInfoForm.get('phoneNumber').errors?.required)">
                    {{ getGlobalErrorMessages("REQUIRED") }}
                </span>
            </div>
            <!-- Email ID -->
            <div class="form-group col-md-4"> 
                <label class="label-cls">Email ID</label>
                <input [ngClass]="isDisabledContact ? 'im-input disable' : 'im-input'"
                        name="emailId"
                        formControlName="emailId"
                        type="text"
                        placeholder="Enter"/>
                <span class="invalid-message" *ngIf="(employerContactInfoForm.get('emailId').touched  && employerContactInfoForm.get('emailId').invalid)">
                    {{ getGlobalErrorMessages("INVALID_EMAIL") }}
                </span>
            </div>
        </div>
    </form>
</div>
<!-- Confirm Reset Modal -->
<p-confirmDialog id="confirm-reset-modal" [style]="{width: '35vw'}"></p-confirmDialog>

</mat-expansion-panel>


